import EditIcon from "@mui/icons-material/Edit";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  Chip,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const SectionCard = ({
                       title,
                       subtitle,
                       children,
                       sectionKey,
                       serviceId,
                       icon,
                       status,
                       isOfferItem = false,
                     }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const getEditRoute = () => {
    const routes = {
      pin: "/Ads-Pin/Edit",
      banner: "/Ads-Main-Page/Edit",
      trust: "/Ads-Trust/Edit",
      tickets_ads: "/Ads-Ticket/Edit",
      top_result: "/Ads-Search-Result/Show"
    };
    return routes[sectionKey];
  };

  const getStatusColor = (status) => {
    const statusColors = {
      active: "success",
      pending: "warning",
      completed: "info",
      cancelled: "error",
    };
    return statusColors[status] || "default";
  };

  const handleEditClick = () => {
    if (sectionKey && serviceId) {
      const route = getEditRoute();
      if (route) {
        navigate(`${route}/${serviceId}`);
      }
    }
  };

  // Allow editing for ALL service types that have a serviceId
  const canEdit = sectionKey && serviceId && sectionKey !== 'trust';

  return (
      <Card
          sx={{
            minWidth: 320,
            maxWidth: 400,
            m: 1,
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            transition: "transform 0.2s, box-shadow 0.2s",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)"
            },
          }}
      >
        <CardHeader
            avatar={
              <Avatar
                  sx={{
                    bgcolor: theme.palette.primary.main,
                    width: 48,
                    height: 48
                  }}
                  src={typeof icon === 'string' ? icon : undefined}
              >
                {typeof icon !== 'string' ? icon : null}
              </Avatar>
            }
            title={
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                  {title}
                </Typography>
                {subtitle && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                      {subtitle}
                    </Typography>
                )}
              </Box>
            }
            action={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {status && (
                    <Chip
                        label={status}
                        color={getStatusColor(status)}
                        size="small"
                    />
                )}
                {canEdit && (
                    <IconButton onClick={handleEditClick} color="primary">
                      <EditIcon />
                    </IconButton>
                )}
              </Box>
            }
            sx={{
              bgcolor: theme.palette.primary.light,
              py: 2,
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            }}
        />
        <CardContent sx={{
          bgcolor: "#fafafa",
          minHeight: 200,
          '&:last-child': { pb: 2 }
        }}>
          {children}

          {canEdit && (
              <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                <Button
                    variant="outlined"
                    startIcon={<EditIcon />}
                    onClick={handleEditClick}
                    fullWidth
                    sx={{ borderRadius: 2 }}
                >
                  Edit Service
                </Button>
              </Box>
          )}
        </CardContent>
      </Card>
  );
};

export default SectionCard;